import { createRoot } from 'react-dom/client';
import FallbackNav from '../components/FallbackNav';
import { addRootNavContainer, getOrAddUtilityBannersContainer, removeNavPlaceholders } from '../../utils/globalToolbarUtils';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { configureStore } from '../../utils/configureStore';
import { applyFallbackNav, initialStore } from '../../reducers/utils/hydrateStore';
import { jsx as _jsx } from "react/jsx-runtime";
export function renderFallbackNav() {
  const fallbackContainer = addRootNavContainer();
  const root = createRoot(fallbackContainer);
  const state = applyFallbackNav(initialStore);
  const store = configureStore(state);
  getOrAddUtilityBannersContainer();
  root.render( /*#__PURE__*/_jsx(ThemeProvider, {
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(FallbackNav, {})
    })
  }));
  removeNavPlaceholders();
}